module.exports = __webpack_public_path__ + "static/media/bg-stardust.04113035.png";